export const ALPHABET: string[] = "abcdefghijklmnopqrstuvwxyz".split("");
